import { Box, Popover, Typography } from '@mui/material';
import CopyToClipboard from 'app/components/CopyToClipboard';

type Props = {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  metricKey: string;
  businessDefinition: string;
  catalogId: string;
};

const fallback = (value: string) => value || '—';

/** Anchored popover: metric key (copy), business definition, catalog id. */
export default function MetricInfoPopover({
  open,
  anchorEl,
  onClose,
  metricKey,
  businessDefinition,
  catalogId,
}: Props) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 2,
          minWidth: 280,
          maxWidth: 380,
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Box>
          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
            Metric key
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mt: 0.25 }}>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, wordBreak: 'break-all', flex: 1 }}
            >
              {fallback(metricKey)}
            </Typography>
            {metricKey ? (
              <CopyToClipboard
                text={metricKey}
                size="small"
                tooltipTitle="Copy metric key"
                aria-label="Copy metric key"
                sx={{ ml: 0, color: 'text.secondary' }}
              />
            ) : null}
          </Box>
        </Box>

        <Box>
          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
            Business definition
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.25, whiteSpace: 'pre-wrap' }}>
            {fallback(businessDefinition)}
          </Typography>
        </Box>

        <Box>
          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
            Catalog ID
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.25, fontWeight: 600 }}>
            {fallback(catalogId)}
          </Typography>
        </Box>
      </Box>
    </Popover>
  );
}
